RivalIQ.module('configuration', function (configuration, App, Backbone, Marionette, $, _) {

    'use strict';

    const messages = configuration.messages = {
        NO_CHANNELS: 0,
        NO_CONTENT: 1,
        NO_COMPETITORS: 2,
        NO_COMPETITOR_TAG_MATCH: 3,
        NO_ALERTS: 4,
        NO_DATA: 5,
        NO_PRESENCE: 6
    };

    configuration.messageDetails = _.tap({}, function (details) {
        details[messages.NO_CHANNELS] = {
            icon: 'fa-warning',
            message: function (model) {
                return `We didn't find any social channels for ${model.get('name')}`;
            },
            action: `If you'd like to add the correct social handles, use ` +
                    `the <a href='/companies'>Companies</a> section.`
        };

        details[messages.NO_CONTENT] = {
            icon: 'fa-warning',
            message: function (model) {
                let subjectName;

                if (model.get('isLandscape')) {
                    subjectName = 'this landscape';
                } else {
                    subjectName = model.get('focusCompany').get('name');
                }

                return `We didn't find any posts for ${subjectName} during the last 7 days.`;
            },
            action: 'Check back later to see what we discover in the future!'
        };

        details[messages.NO_COMPETITORS] = {
            icon: 'fa-warning',
            message: function () {
                return `You don't have any other companies in your landscape`;
            },
            action: `Add competitors to this landscape on the <a href='/companies'>Companies</a> ` +
                    'page.'
        };

        details[messages.NO_COMPETITOR_TAG_MATCH] = {
            icon: 'fa-warning',
            message: function () {
                return 'No competitors match this company set';
            },
            action: 'Change the company set filter at the top of the page to expand the comparison set for this landscape'
        };

        details[messages.NO_ALERTS] = {
            muted: true,
            leading: true,
            icon: 'fa-warning',
            image: '/images/no-alerts.png',
            message: 'Alerts From Your Landscape Will Appear Here',
            orientation: 'vertical'
        };

        details[messages.NO_DATA] = {
            icon: 'fa-warning',
            message: 'We are still pulling and processing data. Check back soon!',
            orientation: 'vertical'
        };

        details[messages.NO_PRESENCE] = {
            icon: 'fa-warning',
            message: function (model) {
                let subjectName;

                if (model.get('isLandscape')) {
                    subjectName = 'other companies in this landscape';
                } else {
                    subjectName = model.get('focusCompany').get('name');
                }

                return `We didn't find any ${model.get('presenceName')} presence for ${subjectName}`;
            },
            action: `If you'd like to add the correct social handles, use ` +
                    `the <a href='/companies'>Companies</a> section.`
        };
    });
});
